import { render, staticRenderFns } from "./RelatedVideo.vue?vue&type=template&id=725ec1aa&scoped=true&"
import script from "./RelatedVideo.vue?vue&type=script&lang=js&"
export * from "./RelatedVideo.vue?vue&type=script&lang=js&"
import style0 from "./RelatedVideo.vue?vue&type=style&index=0&id=725ec1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725ec1aa",
  null
  
)

export default component.exports